import * as React from "react";

import { Context } from "../Context";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as SolidIconSet from "@fortawesome/free-solid-svg-icons";
import * as BrandIconSet from "@fortawesome/free-brands-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export function Contact() {
  const context: any = React.useContext(Context);
  const contact = context.data.contact;
  if (contact === {}) {
    return null;
  }
  return (
    <div id="contact">
      <h2>Contact Me!</h2>
      <div className="grid-x">
        <div className="cell">
          {Object.keys(contact).map(contactKey => {
            return (
              <p key={contactKey}>
                <strong>
                  {renderIcon(contact[contactKey].icon)}
                  {` ${contactKey}`}
                </strong>
                : {contact[contactKey].value}
              </p>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function renderIcon(type: string) {
  // @ts-ignore
  const icon: IconProp = SolidIconSet[type] || BrandIconSet[type];
  return <FontAwesomeIcon icon={icon} />;
}
